import React, { useEffect, useState } from 'react';

import { useRuleContext } from '../../context/RuleStore';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

// Dynamic gradient modal box that cycles through light and dark shades
const GradientModalBox = styled(Box)(({ theme, gradientcolors }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  padding: '2rem',
  borderRadius: '12px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
  backdropFilter: 'blur(10px)',
  border: '2px solid rgba(255, 255, 255, 0.3)',
  
  // Dynamic gradient animation based on the border color
  background: gradientcolors ? `linear-gradient(-45deg, ${gradientcolors.light}, ${gradientcolors.dark}, ${gradientcolors.light}, ${gradientcolors.dark})` : 'linear-gradient(-45deg, #ffcccb, #8b0000, #ffcccb, #8b0000)',
  backgroundSize: '400% 400%',
  animation: 'colorCycle 8s ease infinite',
  
  '@keyframes colorCycle': {
    '0%': {
      backgroundPosition: '0% 50%',
    },
    '50%': {
      backgroundPosition: '100% 50%',
    },
    '100%': {
      backgroundPosition: '0% 50%',
    }
  },
  
  // Style text for better contrast
  '& .MuiTypography-root': {
    color: 'white',
    fontWeight: 'bold',
    textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
  }
}));

const defaultStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '20px ridge red',
  boxShadow: 24,
  width: 400,
  p: 4,
  borderRadius: 10,
};
export const RuleDescriptionModal = (props) => {
  const { state: ruleState, action: ruleActions } = useRuleContext();

  // State
  const [style, setStyle] = React.useState(defaultStyle);
  const [borderStyle, setBorderStyle] = useState({ border: '20px ridge red', borderRadius: 20 });
  const [gradientColors, setGradientColors] = useState({ light: '#ffcccb', dark: '#8b0000' });

  useEffect(() => {
    if (!ruleState.isRuleDescriptionModalOpen) {
      let colorAsNumber = Math.ceil(Math.random() * 8);
      let color, lightShade, darkShade;
      
      switch (colorAsNumber) {
        case 1:
          color = 'red';
          lightShade = '#ffcccb';
          darkShade = '#8b0000';
          break;
        case 2:
          color = 'orange';
          lightShade = '#ffd4b3';
          darkShade = '#cc6600';
          break;
        case 3:
          color = 'yellow';
          lightShade = '#fffacd';
          darkShade = '#b8860b';
          break;
        case 4:
          color = 'green';
          lightShade = '#90ee90';
          darkShade = '#006400';
          break;
        case 5:
          color = 'blue';
          lightShade = '#add8e6';
          darkShade = '#000080';
          break;
        case 6:
          color = 'indigo';
          lightShade = '#e6e6fa';
          darkShade = '#4b0082';
          break;
        case 7:
          color = 'purple';
          lightShade = '#dda0dd';
          darkShade = '#4b0082';
          break;
        case 8:
        default:
          color = 'pink';
          lightShade = '#ffb6c1';
          darkShade = '#c71585';
          break;
      }
      
      const border = '20px ridge ' + color;
      const newStyle = { ...style, border };
      setBorderStyle({ border, borderRadius: 20 });
      setStyle(newStyle);
      setGradientColors({ light: lightShade, dark: darkShade });
    }
  }, [ruleState?.isRuleDescriptionModalOpen]);

  return (
    <>
      <Modal
        open={!!ruleState?.isRuleDescriptionModalOpen}
        onClose={ruleActions.hideRuleDescriptionModalAction}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <GradientModalBox gradientcolors={gradientColors}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {ruleState?.selectedRule?.name}'s Description
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {ruleState?.selectedRule?.description || 'This rule has no description.'}
            <br />
            <br />
            <br />
            Rule made by {ruleState?.selectedRule?.createdBy}
          </Typography>
          <Button 
            onClick={ruleActions.hideRuleDescriptionModalAction}
            sx={{ 
              mt: 2,
              background: 'rgba(255, 255, 255, 0.9)',
              color: 'black',
              fontWeight: 'bold',
              border: '2px solid rgba(255, 255, 255, 0.5)',
              borderRadius: '20px',
              padding: '10px 20px',
              '&:hover': {
                background: 'rgba(255, 255, 255, 1)',
                transform: 'scale(1.05)',
              }
            }}
          >
            Close
          </Button>
        </GradientModalBox>
      </Modal>
    </>
  );
};
